import React, { useRef } from "react";

interface ModalProps {
    onClose: () => void;
    children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ onClose, children }) => {
    const modalContentRef = useRef<HTMLDivElement | null>(null);

    return (
        <div
            className="modal fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            aria-modal="true"
            role="dialog"
        >
            <div
                className="rounded-md shadow-lg w-full max-w-lg sm:max-w-md max-h-[90vh] overflow-auto relative p-6 bg-white dark:bg-gray-800"
                ref={modalContentRef}
            >
                {/* Close Button */}
                <a
                    className="absolute top-4 right-4 text-gray-500 dark:text-gray-300 hover:text-black dark:hover:text-white text-lg sm:text-xl w-8 h-8 flex items-center justify-center"
                    onClick={onClose}
                    aria-label="Close Modal"
                >
                    ✖
                </a>

                {/* Modal Content */}
                <div>{children}</div>
            </div>
        </div>
    );
};

export default Modal;